import type { FC, ReactNode } from "react";

import type {
    AiTrackerReportsSourceAnalysisGraphResponse,
    AiTrackerReportsSourceAnalysisDomainNode,
    AiTrackerReportsSourceAnalysisTopicNode,
    AiTrackerReportsSourceAnalysisDailyDataPoint,
} from "@similarweb/pro-api-client";

import type { IAiTrackerCampaign } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

export type InfluenceView = "treeMap" | "overTimeGraph";
export const InfluenceViews: InfluenceView[] = ["treeMap", "overTimeGraph"];

export interface IInfluenceComponent {
    campaign: IAiTrackerCampaign;
    data: ISourceDomainResponse;
    topicId: string;
}

export interface IDomainMetadata {
    iconUrl?: string | null;
    topicName: string;
    sourceCategory?: string | null;
    subdomainsCount: number;
    urlCount: number;
}

export interface ITopicDropdownItemConfig {
    name: string;
    id: string;
}

export interface ITopicDropdownItem {
    text: string;
    id: string;
}

export interface IViewData {
    component: FC<IInfluenceComponent>;
    icon: ReactNode;
    trackingName: string;
}

export type ISourceDomainResponse = AiTrackerReportsSourceAnalysisGraphResponse;
export type ISourceTopic = AiTrackerReportsSourceAnalysisTopicNode;
export type ISourceDomain = AiTrackerReportsSourceAnalysisDomainNode;
export type IDomainDailyData = AiTrackerReportsSourceAnalysisDailyDataPoint;
